import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Box,
  Button,
  TextField,
  Grid,
} from "@mui/material";
import { FiTrash2, FiEdit2 } from "react-icons/fi";
import { getUserType, addName, editName, deleteUserType,searchUserType } from "../../actions/adminAction";
import Cookies from "universal-cookie";
import { Tooltip } from "react-tooltip";
import { DELETE, EDIT } from "../../constants/url";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { CONFIRM_TITLE, ERR_ALERT_TITLE } from "../../constants/alertMessage";

const cookies = new Cookies();

const UserType = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [values, setValues] = useState({
    name: "",
    error: "",
    header: "Add Type",
    success: false,
    types: [],
    message: "",
    type_id: "",
    type: "add",
    removed: false,
  });
  const {
    name,
    type,
    types,
    type_id,
  } = values;
  const token = cookies.get("agritech_token");

  useEffect(() => {
    loadUserType();
  }, []);

  const loadUserType = () => {
    getUserType(token).then((data) => {
      if (data.error) { 
         Swal.fire({
        icon: "error",
        title: `${ERR_ALERT_TITLE}`,
        text: data.error,
        confirmButtonText: "OK",
      });
      } else {
        setValues({
          ...values,
          types: data.userType,
          name: "",
          type: "add",
          type_id: "",
          header: "Add Type",
        });
      }
    });
  };

  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    searchUserType(searchQuery).then((data) => {
      if (!data) {
        return;
      }
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: `${ERR_ALERT_TITLE}`,
          text: data.error,
          confirmButtonText: "OK",
        });
      } else {
        setValues({
          ...values,
          types: data.userType || [],
          _id: "",
          type: "add",
          header: "Add Type",
          name: "",
        });
      }
    });
  };

  const handleEdit = (row) => {
    setValues({
      ...values,
      error: "",
      name: row.name,
      type: "edit",
      type_id: row._id,
    });
    setShow1(true);
  };

  const handleDelete = (row) => {
    Swal.fire({
      title: `${CONFIRM_TITLE}`,
      text: "",
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: "#d33",
      cancelButtonColor: " #3085d6",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUserType(row._id).then((data) => {
          if (data.error) {
            setValues({ ...values, error: data.error, loading: false });
          } else {
            loadUserType();
            Swal.fire("Deleted!", "User type has been deleted.", "success");
          }
        });
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValues({ ...values, error: "", success: false });

    if (type === "add") {
      addName(name).then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error });
          Swal.fire("Error!", data.error, "error");
        } else {
          setShow(false);
          loadUserType();
          Swal.fire("Added!", "User type added successfully.", "success");
        }
      });
    } else if (type === "edit") {
      editName(name, type_id).then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error });
          Swal.fire("Error!", data.error, "error");
        } else {
          setShow1(false);
          loadUserType();
          Swal.fire("Updated!", "User type updated successfully.", "success");
        }
      });
    }
  };

  const handleChange = (name) => (e) => {
    setValues({ ...values, error: false, [name]: e.target.value });
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="settings" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Customer Type</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Customer Type</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <div style={{ width: "98%" }}>
                  <div className="d-flex align-items-center justify-content-between mb-3" >
                      <button
                        className="btn btn-icon waves-effect waves-light btn-primary"
                        onClick={handleShow}
                      >
                        <i className="fa fa-plus"></i> Add Customer Type
                      </button>
                      <div style={{ width: '200px', position: 'relative',marginLeft: 'auto'}}>
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '100%', paddingLeft: '30px', boxSizing: 'border-box' }}
                          onChange={(e) => {
                            handleSearch(e);
                            if (e.target.value.trim() === '') {
                              e.target.nextElementSibling.style.display = 'inline-block';
                            } else {
                              e.target.nextElementSibling.style.display = 'none';
                            }
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#aaa'
                          }}
                        ></i>
                      </div>
                    </div>
                    <Modal
                      open={show}
                      onClose={handleClose}
                      aria-labelledby="add-customer-type-modal"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "white",
                          padding: 4,
                          width: "60%",
                        }}
                      >
                        <h3 id="add-customer-type-modal">Add Customer Type</h3>
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={2} style={{ marginTop: "20px" }}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                id="name"
                                label="Customer Type"
                                value={name}
                                onChange={handleChange("name")}
                                required
                              />
                            </Grid>
                          </Grid>
                          <div style={{ marginTop: 20, textAlign: "right" }}>
                            <Button
                              variant="outlined"
                              color="error"
                              onClick={handleClose}
                              style={{ marginRight: 10 }}
                            >
                              Close
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              style={{ backgroundColor: "#769A0F" }}
                            >
                              Submit
                            </Button>
                          </div>
                        </form>
                      </Box>
                    </Modal>
                    <Modal
                      open={show1}
                      onClose={handleClose1}
                      aria-labelledby="edit-customer-type-modal"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "white",
                          padding: 4,
                          width: "60%",
                        }}
                      >
                        <h3 id="edit-customer-type-modal">Edit Customer Type</h3>
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={2} style={{ marginTop: "20px" }}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                id="name"
                                label="Customer Type"
                                value={name}
                                onChange={handleChange("name")}
                                required
                              />
                            </Grid>
                          </Grid>
                          <div style={{ marginTop: 20, textAlign: "right" }}>
                            <Button
                              variant="outlined"
                              color="error"
                              onClick={handleClose1}
                              className="mr-3"
                            >
                              Close
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              style={{ backgroundColor: "#769A0F" }}
                            >
                              Update
                            </Button>
                          </div>
                        </form>
                      </Box>
                    </Modal>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ paddingLeft: "100px" }}>S.No</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {types.map((type, index) => (
                            <TableRow key={type._id}>
                              <TableCell style={{ paddingLeft: "100px" }}>{index + 1}</TableCell>
                              <TableCell>{type.name}</TableCell>
                              <TableCell>
                                <span>
                                  <FiEdit2
                                    size="18px"
                                    color="#0978F2"
                                    data-tooltip-id="1"
                                    data-tooltip-content={`${EDIT}`}
                                    onClick={() => handleEdit(type)}
                                  />
                                  <Tooltip id="1" />
                                  <FiTrash2
                                    size="18px"
                                    color="red"
                                    data-tooltip-id="2"
                                    data-tooltip-content={`${DELETE}`}
                                    onClick={() => handleDelete(type)}  // Correctly passing the row object here
                                    style={{ marginLeft: "10px" }}
                                  />
                                  <Tooltip id="2" />
                                </span>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserType;
